module.exports = __webpack_public_path__ + "img/info1.1cf9857b.png";